import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute,Router } from '@angular/router';
import { WalletyRequestService } from '../services/wallety-request.service';
import { environment } from '../../environments/environment';
import { finalize } from 'rxjs/operators';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],

  template:
  `
    <div class="contacts-card">
        <div class="spinner-container" *ngIf="isLoadingPageContent">
        <span class="spinner"></span>
        </div>
    </div>
    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Close
          </button>
        </div>
      </div>
    </div>
  `
})
export class RejectWalletyMeRequestPage{

    requestId = '';
    whatsAppUrl = environment.whatsapp_url;
    showErrorPopup = false;
    errorMessage = '';
    isLoadingPageContent = true;

  constructor(private route: ActivatedRoute, private router: Router, private walletyRequestService: WalletyRequestService) {}

    ngOnInit() {
        this.requestId = this.route.snapshot.paramMap.get('requestId') ?? '';
        if (!this.requestId) {
            this.errorMessage = 'Invalid links';
            this.showErrorPopup = true;
            return;
        }
        this.postRejectRequest();
      }
    postRejectRequest() {
        this.walletyRequestService
        .postRejectRequest(this.requestId)
        .subscribe({
            next: response => {
               window.location.href = this.whatsAppUrl;
                return;
            },
            error: err => {
                this.isLoadingPageContent = false;
                this.errorMessage = err.error?.message ?? 'Unable to load page.';
                this.showErrorPopup = true;
            }
            },
        );
    }
    closeErrorPopup(): void {
        window.location.href = this.whatsAppUrl;
    }
}